module.exports = __webpack_public_path__ + "img/appAsset--purchase-ax.9d2cd7b5.svg";